<div class="flex justify-between w-full border-b items-center h-full">
  <!-- Hamburger -->
  <div class="grow shrink-0 truncate p-2">
    <div (click)="onLeftButtonClick.emit()">
      <mat-icon class="align-middle">{{ leftButtonIcon }}</mat-icon>
    </div>
  </div>
  <!-- Title -->
  <div class="grow shrink-0 truncate text-center p-2">
    <div>
      <span>{{ title }}</span>
    </div>
  </div>
  <!-- Action -->
  <div class="grow shrink-0 truncate p-2 flex justify-end">
    <div>
      <mat-icon class="align-middle">{{ rightButtonIcon }}</mat-icon>
    </div>
  </div>
</div>
